import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DatePipe } from '@angular/common';
import { Http, Headers, RequestOptions, Response, ResponseContentType, URLSearchParams } from "@angular/http";
import { GlobalService } from '../../services/global.service';
import 'rxjs/add/operator/map';
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { convertToView } from 'ionic-angular/navigation/nav-util';
import { MyPosProvider } from '../../providers/my-pos/my-pos';

/**
 * Generated class for the DailyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-daily',
  templateUrl: 'daily.html',
})
export class DailyPage {
  DateFrom: Date = new Date();//.toISOString();
  DateTo: Date= new Date(); //.toISOString();
  Mylist: Array<any>=[];
  MyArr: Array<any>=[{"$id":"1","MGroup":"المخزون","MAccountName":"المخزون","MAccountSerial":"256","MaccountBalance":"-1284213.691"},{"$id":"2","MGroup":"المخزون","MAccountName":"منصرف بدون قيمة","MAccountSerial":"264","MaccountBalance":"352444.539"},{"$id":"3","MGroup":"الاموال","MAccountName":"البنك العربي الافريقي حساب رقم 507385","MAccountSerial":"257","MaccountBalance":"59800.000"}];
  Visible:boolean=false;
  MyHeaderArr: Array<any>=[];
  MyDetailsArr: Array<any>=[];
  MyShowArr:Array<boolean>=[false,false,false,false];
  MyHKeysArr:Array<any>=["مبيعات","مشتريات","مصروفات","تحصيل","سداد","تحويل اموال"];
  MyHKeysArr1:Array<any>=["مبيعات","مشتريات"];
  MyHKeysArr2:Array<any>=["مصروفات","تحصيل","سداد","تحويل اموال"];
MyReturnArr:Array<any>=["2","23","24","41"];
  MyDKeysArr:Array<any>=[];//any[][]=[ ];
  constructor(public navCtrl: NavController, public navParams: NavParams, private global: GlobalService,private http:Http
    ,public alertCtrl: AlertController,public loadingCtrl: LoadingController,public datepipe: DatePipe,public PosProvider:MyPosProvider) {
  }
  View():void{
    if(this.DateFrom!==null && this.DateTo !==null)
   {
    this.Visible=true;
  let loader = this.loadingCtrl.create({
    content: "Please wait...",
    //duration: 3000,
  });
  loader.present();
  //var d =this.DateFrom;
  let Df=this.datepipe.transform(this.DateFrom, 'yyyy-MM-dd');
  //d.getFullYear().toString()+"-"+d.getMonth().toString()+
  //d.getDay().toString();
  
  //var dd =this.DateTo;
  let Dt=this.datepipe.transform(this.DateTo, 'yyyy-MM-dd');
  //dd.getFullYear().toString()+"-"+dd.getMonth().toString()+
  //dd.getDay().toString();
  //2017-3-1_2018-3-3
  this.http.get(this.PosProvider.MyDomain+'/api/sense/GetDaily/'+Df+"_"+Dt)   
     .map(res => res.json())      
     .subscribe(data => {          
          this.Mylist = data; 
          //this.Mylist.forEach(element => {
          //  this.TotalVal=this.TotalVal+Number( element.MaccountBalance);
          //});
          //this.TotalVal=parseInt( this.TotalVal.toString());
          //-----
         // this.Mylist.forEach(element => {
          //  let ifxeist=false;
          //  this.MySummArr.forEach(elementG=>
         //    {
                       

          //   });
          // if(element.MGroup==Gname)
         //  {
         //  }
         // });    
          //--------      
     loader.dismiss();
},err => {
console.log(err);
loader.dismiss();
const alert = this.alertCtrl.create({
  title: 'Error message',
  subTitle: err,
  buttons: ['OK']
});
alert.present();
});
//let TotalValue=0;
//let TmpGroup=this.Mylist[0].MGroup;
//let indxx=0;
//let Dindxx=-1;
//let tmpArr=[];
//let tmpKeyArr=[];
//let tmpObject;
let TmpGroup="";
//this.Mylist.forEach(element => {
//  if(element.MGroup !=TmpGroup)
//  {   
//  this.MyHKeysArr.push(element.MGroup);
//  this.MyShowArr.push(false);
//  TmpGroup=element.MGroup;
//  }
// });
}
}

hideMe:boolean=false;
GetVisible(Gr):boolean
{
let l=true;
let indxx=0;
this.MyHKeysArr.forEach(element => {
  

if(element==Gr)
{
l=this.MyShowArr[indxx];

}
 indxx++;
});
return l;
}
hide( Gr) {
// this.hideMe = !this.hideMe;
let indxx=0;
this.MyHKeysArr.forEach(element => {     
if(element==Gr)
{
this.MyShowArr[indxx]=!this.MyShowArr[indxx];

}
indxx++;
});
}

//MySummArr: Array<number>=[];
TotalVal:number=0;
Getsum(Gname):any
{
let TArr=[];
let SummT=0;
//let indxx=0;
this.Mylist.forEach(element => {
  if(element.CGroup==Gname)
  { 
    if(Gname=="مبيعات"||Gname=="مشتريات")
    {
    if(this.MyReturnArr.indexOf(element.CInvT) > -1)
    { 
      SummT=SummT-Number( element.CLineTotal);  
    }
    else
    {
      SummT=SummT+Number( element.CLineTotal);  
    }
  }
  else  
  {
    SummT=SummT+Number( element.CLineTotal);  
  }
    //let objj={"MAccountName":element.MAccountName,"MaccountBalance":element.MaccountBalance};
    //TArr.push(objj);
    //this.MySummArr[indxx]=this.MySummArr[indxx]+ element.MaccountBalance;
  }
  //indxx;
});
//this.TotalVal=this.TotalVal+SummT;
return parseInt( SummT.toString());
 }


 GetColor(Myi):any
 {
  
  if(this.MyReturnArr.indexOf(Myi.CInvT) > -1)
  { 
    return 'red';
  }
  else
  {
    return 'black';
  }

 }
GetDetails(Gname):any
{
let TArr=[];
let indxx=0;
this.Mylist.forEach(element => {
  if(element.CGroup==Gname)
  {       
    let objj={"CInvT":element.CInvT,"CInvTDesc":element.CInvTDesc,"CInvID":element.CInvID,"CIID":element.CIID,"CInvDate":element.CInvDate,"CIName":element.CIName,"CQuantity":parseFloat(element.CQuantity).toString()
    ,"CPDisc":parseFloat(element.CPDisc).toString(),"CLineTotal":parseFloat(element.CLineTotal).toString()};
    TArr.push(objj);
    //this.MySummArr[indxx]=this.MySummArr[indxx]+ element.MaccountBalance;
  }
  indxx;
});
return TArr;

 }
  ionViewDidLoad() {
    console.log('ionViewDidLoad DailyPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/daily/daily.ts